import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import { PPCAuthProvider, usePPCAuth } from './PPCContext';
import './ppc-styles.css';

// Import PPC Dashboard Components
import DashboardSelector from './DashboardSelector';
import BravoDashboard from './BravoDashboard';
import RomeoDashboard from './RomeoDashboard';
import PapaDashboard from './PapaDashboard';
import GolfDashboard from './GolfDashboard';
import UserManagement from './UserManagement';
import EditRequests from './EditRequests';
import ContractorMaster from './ContractorMaster';
import ViewerDashboard from './ViewerDashboard';
import PPCContractors from './PPCContractors';
import PPCUsers from './PPCUsers';
import PPCRequests from './PPCRequests';

// PPC Protected Route
const PPCProtectedRoute = ({ children }) => {
  const { user, loading } = usePPCAuth();
  
  if (loading) {
    return <div className="ppc-loading">Loading...</div>;
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

// PPC Admin Route
const PPCAdminRoute = ({ children }) => {
  const { user, loading } = usePPCAuth();
  
  if (loading) {
    return <div className="ppc-loading">Loading...</div>;
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  if (user.role !== 'admin') {
    return <Navigate to="/ppc" replace />;
  }
  
  return children;
};

// PPC Viewer Route
const PPCViewerRoute = ({ children }) => {
  const { user, loading } = usePPCAuth();
  
  if (loading) {
    return <div className="ppc-loading">Loading...</div>;
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  if (user.role !== 'viewer') {
    return <Navigate to="/ppc" replace />;
  }
  
  return children;
};

// Main PPC Layout Component
const PPCLayout = () => {
  return (
    <PPCAuthProvider>
      <div className="ppc-app">
        <Routes>
          {/* PPC Dashboard Selector (Home) */}
          <Route index element={
            <PPCProtectedRoute>
              <DashboardSelector />
            </PPCProtectedRoute>
          } />
          
          {/* Bravo Dashboard */}
          <Route path="bravo" element={
            <PPCProtectedRoute>
              <BravoDashboard />
            </PPCProtectedRoute>
          } />
          
          {/* Papa Dashboard */}
          <Route path="papa" element={
            <PPCProtectedRoute>
              <PapaDashboard />
            </PPCProtectedRoute>
          } />
          
          {/* Romeo Dashboard */}
          <Route path="romeo" element={
            <PPCProtectedRoute>
              <RomeoDashboard />
            </PPCProtectedRoute>
          } />
          
          {/* Golf Dashboard */}
          <Route path="golf" element={
            <PPCProtectedRoute>
              <GolfDashboard />
            </PPCProtectedRoute>
          } />
          
          {/* User Management (Admin Only) */}
          <Route path="users" element={
            <PPCAdminRoute>
              <UserManagement />
            </PPCAdminRoute>
          } />
          
          {/* Edit Requests (Admin Only) */}
          <Route path="edit-requests" element={
            <PPCAdminRoute>
              <EditRequests />
            </PPCAdminRoute>
          } />
          
          {/* Contractor Master (Admin Only) */}
          <Route path="contractor-master" element={
            <PPCAdminRoute>
              <ContractorMaster />
            </PPCAdminRoute>
          } />
          
          {/* Viewer Dashboard */}
          <Route path="viewer" element={
            <PPCViewerRoute>
              <ViewerDashboard />
            </PPCViewerRoute>
          } />
          
          {/* ── NEW: Rebuilt Admin Pages ── */}
          <Route path="contractors" element={
            <PPCAdminRoute>
              <PPCContractors />
            </PPCAdminRoute>
          } />

          <Route path="ppc-users" element={
            <PPCAdminRoute>
              <PPCUsers />
            </PPCAdminRoute>
          } />

          <Route path="requests" element={
            <PPCAdminRoute>
              <PPCRequests />
            </PPCAdminRoute>
          } />

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/ppc" replace />} />
        </Routes>
      </div>
    </PPCAuthProvider>
  );
};

export default PPCLayout;
